import * as helper from './../../../../../VX/View/Assets/Js/helper';
import * as Events from "./Events";
import {dialog1} from "./Dialog1";
import {textReplacer} from "./TextReplacer";
import {getGirl} from "./PeopleGetter";

export function initDialogHandler() {
	helper.addEventListener(window, Events.MESSAGE_SENT, (data) => {
		if (data.detail.type === 'guest') {
			const message = data.detail.message;
			for (let dialogOption of dialog1) {
				const keywords = new RegExp(dialogOption.keywords.replace(/\//g, '|').replace(/\)/g, ')?'), 'gi');
				if (message.match(keywords) && dialogOption.used === false) {
					console.log(message, keywords);

					const girl = getGirl();
					dialogOption.used = true;

					setTimeout(() => {
						helper.triggerEvent(window, Events.MESSAGE_SENT, {
							name: girl.name,
							id: girl.id,
							message: textReplacer(dialogOption.reply, girl.name),
							image: girl.avatar,
							type: 'host',
							reply: true,
						})
					}, 3000);
					break;
				}
			}
		}
	});
}
